var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.Music.url)?_c('div',{staticClass:"MusicBox",on:{"click":_vm.PlayerMusic}},[_c('span',{staticClass:"icon iconfont iconyinle MusicIcon",class:{MusicIconPlay:_vm.isPlay}}),_vm._v(" "),_c('audio',{attrs:{"id":"MusicPlayer","src":_vm.Music.url}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ce29af1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Music.vue
// module id = null
// module chunks = 